import { render, staticRenderFns } from "./CarouselFormat.vue?vue&type=template&id=2126ab16&scoped=true&"
import script from "./CarouselFormat.vue?vue&type=script&lang=js&"
export * from "./CarouselFormat.vue?vue&type=script&lang=js&"
import style0 from "./CarouselFormat.vue?vue&type=style&index=0&id=2126ab16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126ab16",
  null
  
)

export default component.exports